<div style="display: flex; justify-content: space-around">
  <primary-text-button *ngIf="classificationType.id" (onClick)="initData()">
    {{ 'classification.other.edit' | translate }}
  </primary-text-button>
  <primary-text-button (onClick)="initDataForAdd()">
    {{'general.add' | translate }}
  </primary-text-button>
  <confirmation [buttonName]="'general.delete'" [question]="'confirm.areyousure'"
    (isConfirmed)=deleteClassificationType($event) *ngIf="classificationType.id != undefined">
  </confirmation>
</div>

<div bsModal #lgModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
  aria-hidden="true" align="left">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="container-fluid">
        <div class="row py-3 mb-3 modal-header">
          <div class="col-1 py-1 text-center">
            <i class="far fa-times close-icon" (click)="cancel()"></i>
          </div>
          <div class="col-11">
            <h2 class="modal-title">{{ 'classification.other.modal_title' | translate }}</h2>
          </div>
        </div>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            <div class="panel panel-default table-dynamic">
              <div class="panel-body">
                <form name="itemForm" role="form" no-validate>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-12">
                        <label class="input-label field-required">{{ 'classification.other.value' | translate }}</label>
                        <input class="form-control" type="text" name="name" [(ngModel)]="classificationType.name"
                          required>
                      </div>
                    </div>
                    <br>
                    <div class="row">
                      <div class="col-md-12">
                        <label class="ui-checkbox">
                          <input class="form-control" name="classificationOnForm" type="checkbox"
                            [ngModel]="classificationType?.classificationOnForm"
                            (ngModelChange)="classificationOnFormSelected($event)">
                          <span>{{ 'classification.other.classificationOnForm' | translate }}</span>
                        </label>

                      </div>
                    </div>
                  </div>

                  <div class="row-fluid">
                    <button (click)="save();"
                      class="btn btn-md btn-outline-primary text-uppercase text-button--primary text-button--no-left-padding mr-2">
                      {{ 'Save' | translate }}
                    </button>
                    <button (click)="cancel()" type="button"
                      class="btn btn-md btn-outline-primary text-uppercase text-button--primary text-button--no-left-padding mr-2">{{
                      'Cancel' | translate }}
                    </button>
                    <confirmation [buttonName]="'general.delete'" [question]="'confirm.areyousure'"
                      (isConfirmed)=deleteClassificationType($event) *ngIf="classificationType.id != undefined">
                    </confirmation>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
